resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';// Custom Asserts for Validator
( function ( factory ) {
    if ( typeof define === 'function' && define.amd ) {
        define( [ 'validator'], factory); // AMD
    } else if ( typeof exports === 'object' ) {
        module.exports = factory( require( './validator.js' ) ); // Node
    } else {
        factory( window[ 'undefined' !== typeof validatorjs_ns ? validatorjs_ns : 'Validator' ] ); // Browser global
    }
}( function ( validator ) {

    validator.Assert.prototype.PostalCode = function() {
        this.__class__ = 'PostalCode';

        this.validate = function ( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value )
                    new validator.Assert().Regexp("^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]( )?\\d[ABCEGHJKLMNPRSTVWXYZ]\\d$", "i").validate( value );
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.ValidDate = function() {
        this.__class__ = 'ValidDate';

        this.validate = function ( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value ) {
                    var result = true;
                    var values = value.split("/");
                    if (values[0] < 1900)
                        throw new validator.Violation( this, value );
                    var date = new Date(parseInt(values[0]), parseInt(values[1]-1), parseInt(values[2]));
                    var convertedDate = "" + date.getFullYear() + "/" + (date.getMonth()+1) + "/" + date.getDate();
                    var givenDate = "" + parseInt(values[0]) + "/" + parseInt(values[1]) + "/" + parseInt(values[2]);
                    if (convertedDate != givenDate)
                        throw new validator.Violation( this, value );
                }
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.Password = function() {
        this.__class__ = 'Password';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if (value.length < 8)
                    throw new validator.Violation( this, value );
                else
                    new validator.Assert().Regexp(".*[0-9].*", "").validate( value );
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.PhoneNumber = function() {
        this.__class__ = 'PhoneNumber';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value )
                    new validator.Assert().Regexp("^\\(\\d{3}\\) \\d{3}-\\d{4}$", "").validate( value );
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.Money = function() {
        this.__class__ = 'Money';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value ) {
                    var val = value.replace(/ /g, '').replace(/\$/g, '');
                    new validator.Assert().Regexp("^[0-9]{1,6}$", "").validate(val);
                }
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.ProperName = function() {
        this.__class__ = 'ProperName';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value ) {
                    new validator.Assert().Regexp("^[ a-zA-Z0-9. -]+$", "").validate(value);
                }
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.Integer = function() {
        this.__class__ = 'Integer';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value ) {
                    new validator.Assert().Regexp("^\\d+$", "").validate(value);
                }
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    validator.Assert.prototype.SIN = function() {
        this.__class__ = 'SIN';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value )
                    new validator.Assert().Regexp("^\\d{9}$|^\\d{3}-\\d{3}-\\d{3}$|^\\d{3} \\d{3} \\d{3}$", "").validate( value.trim() );
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }

            return true;
        };

        return this;
    };

    // Override default Choice implement to support Arrays
    validator.Assert.prototype.Choice = function(list) {
        this.__class__ = 'Choice';

        var _isArray = function ( obj ) {
            return Object.prototype.toString.call( obj ) === '[object Array]';
        };

        if ( !_isArray( list ) && 'function' !== typeof list )
            throw new Error( 'Choice must be instanciated with an array or a function' );

        this.list = list;

        this.validate = function ( value ) {
            var list = 'function' === typeof this.list ? this.list() : this.list;

            if (value instanceof Array) {
                if (value.length == 0) return false;

                for (var j = 0; j < value.length; j++) {
                    var res = false;
                    for ( var i = 0; i < list.length; i++ ) {
                        if ( value[j] === list[ i ] ) {
                            res = true;
                            break;
                        }
                    }
                    if (!res)
                        return false;
                }
                return true;
            } else {
                for ( var i = 0; i < list.length; i++ )
                    if ( value === list[ i ] )
                        return true;
            }

            throw new Violation( this, value, { choices: list } );
        };

        return this;
    };

    validator.Assert.prototype.NotRegexp = function(regexp){
        this.__class__ = 'NotRegexp';

        this.validate = function( value ) {
            if ( 'undefined' === typeof value )
                throw new validator.Violation( this, value );

            try {
                if ( 'string' === typeof value ) {
                    var validRegexp = new RegExp(regexp);
                    if (value.match(validRegexp) != null) return false;
                }
            } catch ( violation ) {
                throw new validator.Violation( this, value );
            }
            return true;
        };
        return this;
    }

} ) );